export default "__VITE_ASSET__n6VNhUbw__"